var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSingleLeftArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03384 6.28824L1.03385 6.28825L4.80536 10.3192C5.1243 10.6602 5.64738 10.6603 5.96625 10.3192C6.27794 9.98594 6.27792 9.45076 5.96618 9.11759C5.96618 9.11759 5.96618 9.11758 5.96618 9.11758L2.75679 5.68743L5.96608 2.2574L5.96611 2.25737C6.27781 1.92409 6.27786 1.38894 5.96611 1.05571L1.03384 6.28824ZM1.03384 6.28824C0.876716 6.12028 0.8 5.9023 0.8 5.68741C0.8 5.47264 0.876577 5.25479 1.03372 5.08675L1.03375 5.08672M1.03384 6.28824L1.03375 5.08672M1.03375 5.08672L4.8053 1.05568C4.8053 1.05568 4.8053 1.05568 4.8053 1.05568M1.03375 5.08672L4.8053 1.05568M4.8053 1.05568C5.12423 0.714801 5.6472 0.714747 5.96608 1.05568L4.8053 1.05568Z",
    fill: "#535353",
    stroke: "#535353",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleLeftArrow);
export default __webpack_public_path__ + "static/media/single-left-arrow.e51b519e50cf436df52cac5c6417d073.svg";
export { ForwardRef as ReactComponent };